import React, { useState, useEffect} from 'react';

import './Module.scss';
import { getModuleStatusStr} from '../../utils/utils';
import ModuleDetail from './ModuleDetail';
import { ToolTip } from '../';
import removeSpace from '../../constants/removeSpace';
import {lockMsg, lockMsgAdmin} from '../../constants/messages';
import { ADMIN_ROLE } from '../../constants/global';

const Module = ({ mindex, isLocked, json, statusOfModule, org_rol, setCatStatus, dispatcher, state,showModuleLock, curcat

}) => {

  const { module_tooltip, title, question_groups, id, module_status, last_updated_at, org_id, cat_id } = json;

  //for update date
  const [moduleStatus, setModuleStatus] = useState(module_status);
  const [lastUpdatedAt, setLastUpdatedAt] = useState(last_updated_at);
  const [displayStatus, setDisplayStatus] = useState('');

  useEffect(() => {
    setDisplayStatus(() => getModuleStatusStr(moduleStatus, lastUpdatedAt));
  }, [moduleStatus, lastUpdatedAt]);

  return (
    <div key={mindex} id={`moduleContainer_${mindex}`} className='cb-accordion-container'>
      <a href="#" className="cb-accordion-heading">
        {/* <div className="cb-accordion-heading-title"> */}
        <div style={{display:'flex', alignItems:'center'}}>
          <span style={{width:'100%'}}>
            <div className='row moduleRow marginBottom15'>
              <div className='col-md-9 display-flex align-items-center'>
                <h3 className='title' id={`moduleName${id}`} data-testid={`title${id}`}>{title ? title : 'Module_TITLE'}&nbsp;&nbsp;
                {
                  showModuleLock===true?
                  <ToolTip tooltipid={'tip_CDS_'+cat_id+'_'+id} 
                  tooltipMsg={org_rol===ADMIN_ROLE?lockMsgAdmin:lockMsg} 
                  innerMsg={''} className={'cb-icon cb-lock'} />:<></>
                }
                </h3>
                {
                  module_tooltip ? <div style={{ marginTop: '10px' }}><ToolTip tooltipid={`moduleid${removeSpace(`${title}`.replace(/[^a-zA-Z ]/g, 'id'))}`} tooltipMsg={module_tooltip} /></div> : ''
                }
              </div>
              <div className='col-md-3' id={`moduleStatus${id}`} style={{ textAlign: 'right' }}>
              </div>
            </div>
          </span>

          <div className="cb-accordion-icon">
            <span className="line top"></span>
            <span className="line bottom"></span>
          </div>
        </div>
      </a>
      <div className="cb-accordion-panel cb-white-gradient-top transition" tabIndex="-1" role="region">

        <div className="cb-accordion-panel-content">
        <div id={`moduleView-${id}`} className='marginBottom15'>
             <ModuleDetail
               setModuleStatus={setModuleStatus}
               setLastUpdatedAt={setLastUpdatedAt}
               question_groups={question_groups}
               isLocked={isLocked}
               cat_id={cat_id}
               org_rol={org_rol}
               org_id={org_id}
               id={id}
               statusOfModule={statusOfModule}
               setCatStatus={setCatStatus}
               dispatcher={dispatcher}
               state={state}
               curcat={curcat}
               />
        </div>
        </div>
      </div>
    </div>
  );
};

export default Module;